import React from 'react';
import { number, shape, func, arrayOf } from 'prop-types';
import { v1 as uuid } from 'uuid';

import Box from '@material-ui/core/Box';

import LocationsAutocomplete from '../LocationsAutocomplete';

const LocationsInput = ({
  numberOfLocations,
  selected,
  selectAddress,
  removeLocation,
  removeAddress,
  limits: { max, min },
  setHasError,
}) => {
  const canRemoveLocation = (index, length) => Boolean(index > 0 && length > min);

  const placeholder = i => {
    if (i === numberOfLocations - 1) {
      return 'Destination';
    }
    if (i > 0) {
      return 'Additional address';
    }
    return 'Starting address';
  };

  return (
    <>
      {[...Array(numberOfLocations)].map((_, i) => {
        if (i >= max) {
          return null;
        }
        return (
          <Box key={uuid()} display="flex" flexDirection="row" justifyContent="space-between">
            <Box flex={1} py={1}>
              <LocationsAutocomplete
                testid="location"
                index={i}
                placeholder={placeholder(i)}
                location={selected?.[i]}
                numberOfLocations={numberOfLocations}
                selectAddress={selectAddress}
                removeAddress={removeAddress}
                setHasError={setHasError}
                canRemoveLocation={canRemoveLocation}
                removeLocation={removeLocation}
              />
            </Box>
          </Box>
        );
      })}
    </>
  );
};

LocationsInput.propTypes = {
  numberOfLocations: number.isRequired,
  selected: arrayOf(shape({})).isRequired,
  selectAddress: func.isRequired,
  removeLocation: func.isRequired,
  limits: shape({
    max: number.isRequired,
    min: number.isRequired,
  }).isRequired,
  setHasError: func.isRequired,
  removeAddress: func.isRequired,
};

export default LocationsInput;
